import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { COMMON_GAME_SET } from '#src/set/index.ts';

const StyledImg = styled.img`
  object-fit: contain;
`;

type Props = {
  className?: string;
  style?: CSSProperties;
};
export const SetLogo = ({ className, style }: Props) => {
  return (
    <StyledImg
      src={COMMON_GAME_SET.visual.brand.logoImage}
      alt={COMMON_GAME_SET.cardSet.displayName}
      className={className}
      style={style}
    />
  );
};
